import { Inject, Injectable } from '@angular/core';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { mergeMap, map } from 'rxjs/operators';
import { throwError, of, Observable } from 'rxjs';
import { UserPreference } from '../types/user-preferences.types';

@Injectable()
export class UserPreferencesService {
  private apiHost: any;
  constructor(
    private httpClient: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) environmentConfig: EnvironmentConfig
  ) {
    this.apiHost = environmentConfig.params['apiHost'];
  }

  public load(): Observable<UserPreference[]> {
    const url = `${this.apiHost}/v1/user-preferences`;

    return this.httpClient
      .get(url, {
        observe: 'response'
      })
      .pipe(
        mergeMap((response: HttpResponse<UserPreference[]>) => {
          const data = response.status === 200 && response.body;

          return data
            ? of(data)
            : throwError(Error('Cannot load User Preferences'));
        })
      );
  }

  public delete(id: string): Observable<UserPreference[]> {
    const url = `${this.apiHost}/v1/user-preferences/${id}`;
    return this.httpClient.delete(url, { observe: 'response' }).pipe(
      mergeMap((response: HttpResponse<UserPreference[]>) => {
        if (response.status === 200 && response.body) {
          return of(response.body.filter((el) => el.id !== id));
        }
        return throwError(Error('Cannot delete'));
      })
    );
  }
  public save(userPreference: UserPreference) {
    const url = `${this.apiHost}/v1/user-preferences`;
    return this.httpClient
      .post(url, userPreference, {
        observe: 'response'
      })
      .pipe(
        map((response: HttpResponse<UserPreference>) => {
          const success = response.status === 200 && response.body;
          if (success) {
            return response.body;
          }
          throw new Error('Cannot save User Preferences');
        })
      );
  }
}
